import _ from 'underscore';
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Uri from 'urijs';
import { withI18nConsumer } from '@bingads-webui-react/i18n-context';
import { Button } from '@bingads-webui-react/primitive';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { getRoutePathById, findSiteMap, getNewScope } from '@bingads-webui-react/with-site-map';
import { StyledHeader } from './header';
import { getToolbarElementsStyles } from '../../styles';

export const getButtonClassNames = (classes, customizedNames, responsiveSize, isActive) => {
  const classNamesArray = [
    classes.commonButton,
    classes.toggleable,
  ].concat(customizedNames);

  if (responsiveSize === 'l') {
    classNamesArray.push(classes.compactButton);
  } else {
    classNamesArray.push(classes.standardButton);
  }

  if (isActive) {
    classNamesArray.push(classes.activeButton);
  }
  return classNames(classNamesArray);
};

export const getNavigationObjectBySiteMap = ({
  scope,
  siteMap,
  siteMapId,
  userContext,
  getAbsoluteIfExists = false,
}) => {
  const siteMapItem = findSiteMap(siteMap, s => s.id === siteMapId);
  if (_.isEmpty(siteMapItem)) {
    return null;
  }

  const pathname = getRoutePathById(siteMap, siteMapId, getAbsoluteIfExists);
  const search = scope.stringify(getNewScope(scope.values, siteMapItem.scope, userContext));
  const href = Uri(pathname).search(search).toString();

  return {
    siteMapItem,
    pathname,
    search,
    href,
  };
};

export const navigateBySiteMap = ({
  scope,
  siteMap,
  siteMapId,
  history,
  location,
  userContext,
}) => {
  const navigationObject = getNavigationObjectBySiteMap({
    scope,
    siteMap,
    siteMapId,
    userContext,
  });

  if (!navigationObject) {
    return false;
  }

  const {
    siteMapItem,
    pathname,
    search,
  } = navigationObject;

  if (siteMapItem && siteMapItem.isUnifiedProductPage) {
    // UP page redirects only when scope changes, please don't remove it
    scope.save(pathname);
  } else {
    history.push({
      pathname,
      search,
    });
  }

  // reload page when we are on same host but different controller
  if (location.pathname.indexOf(siteMapItem.routePrefix) !== 0 &&
    !new Uri(pathname).is('absolute')) {
    window.location.reload();
  }

  return true;
};

export const createToolbarButton = (customClasses, glyphName) => {
  const ToolbarButtonInternal = React.memo(({
    classes, onClick, responsiveSize, text, id, isActive, svgicon,
  }) => (
    <Button
      className={getButtonClassNames(
        classes,
        customClasses,
        responsiveSize,
        isActive
      )}
      btnStyle="primary"
      onClick={onClick}
      id={id}
      title={text}
    >
      <StyledHeader
        glyph={glyphName}
        text={text}
        responsiveSize={responsiveSize}
        svgicon={svgicon}
      />
    </Button>
  ));

  ToolbarButtonInternal.defaultProps = {
    text: undefined,
    id: undefined,
    isActive: false,
    svgicon: undefined,
  };

  ToolbarButtonInternal.propTypes = {
    classes: PropTypes.shape({}).isRequired,
    onClick: PropTypes.func.isRequired,
    responsiveSize: PropTypes.string.isRequired,
    text: PropTypes.string,
    id: PropTypes.string,
    isActive: PropTypes.bool,
    svgicon: PropTypes.node,
  };

  return withDefaultStyles(withI18nConsumer(ToolbarButtonInternal), getToolbarElementsStyles);
};
